'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44(evaluator$29) {
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$44__f_evaluator$9 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$44__f_evaluator$9 = evaluator$29;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$44() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$44 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$44 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$44.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestsAcceptedListItem$$anon$44__f_evaluator$9.apply__O();
  return (((typeof v) === "boolean") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$44 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$44, "app.api.DrugRequestsAcceptedListItem$$anon$44", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$44: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$44 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$44 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$44.js.map
